<template>
  <footer>
    <div class="footer" v-if="content.data.footer">
      <div class="row no-gutters" v-if="content.data.footer.partner_visible">
        <div class="col-6" ><div class="footer__partner" v-html="content.data.footer.partner_title"></div><a :href="content.data.footer.partner_link" target="_blank" rel="nofollow"><img :src="content.data.footer.partner_img"></a></div>
        <div class="col-6">
           <div>
            <router-link class="footer__link" to="/kontakt"
              >Kontakt</router-link
            >
          </div>        
          <div>
            <router-link class="footer__link" to="/pytania-i-odpowiedzi"
              >Pytania i odpowiedzi</router-link
            >
          </div>
            <div>
            <router-link class="footer__link" to="/regulamin"
              >Regulamin</router-link
            >
          </div>
          <div>
            <router-link class="footer__link" to="/prywatnosc">
              Polityka prywatności</router-link
            >
          </div>
        </div>
      </div>
      <div v-else class="row no-gutters">
        <div class="col-6">
          <div>
            <router-link class="footer__link" to="/kontakt"
              >Kontakt</router-link
            >
          </div>        
          <div>
            <router-link class="footer__link" to="/pytania-i-odpowiedzi"
              >Pytania i odpowiedzi</router-link
            >
          </div>
        </div>
        <div class="col-6">
            <div>
            <router-link class="footer__link" to="/regulamin"
              >Regulamin</router-link
            >
          </div>
          <div>
            <router-link class="footer__link" to="/prywatnosc">
              Polityka prywatności</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <a href="https://www.greenpeace.org/poland" target="_blank">
        <img src="../assets/images/logo_greenpeace.png" />
      </a>
      <div>&#169; {{ currentYear }} by Fundacja Greenpeace Polska</div>
    </div>
    <div class="footer__grass"></div>
  </footer>
</template>

<script>

export default {
  name: "Footer",
  inject:["content"],
  data() {
    return {
      title: "footer",
      currentYear: new Date().getFullYear(),
    };
  },

};
</script>


